import { Component, OnInit, ViewChild } from '@angular/core';
import { TramRegistroService } from '../../../services/database/tramRegistro.service';
import { ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, LoadingPanelService, Utils } from 'lib-base';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetActividadesPendienteAsignacion, IGetUsuariosValidos } from '../../../shared/interfaces/database/tramite';
import { TramActividadService } from '../../../services/database/tramActividad.service';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-tramites-pendiente-asignacion',
  standalone: true,
  imports: [CustomTableComponent, FormsModule, DialogModule, CommonModule, ReactiveFormsModule, TranslateModule,
      ButtonModule, DropdownModule, FormGroupErrorMessageComponent],
  template: `
  <custom-table [config]="customTable">
  </custom-table>
  <section>
    <form [formGroup]="form" (ngSubmit)="onSubmitForm()">
      <p-dialog [header]="'msg.asignarUsuario' | translate" [(visible)]="displayModal" [modal]="true"
        [breakpoints]="{'960px': '100vw'}" [style]="{width: '60vw'}" [draggable]="false" [resizable]="true"
        [maximizable]="true">
        <div class="grid">
          <div class="field col-12 flex flex-column">
            <label for="usuarioId">{{"common.usuarioAsignado" | translate}}<span style="color: red">*</span></label>
            <p-dropdown [options]="usuariosValidos" appendTo="body" placeholder="Usuario..." optionLabel="nombre" optionValue="id"					
              formControlName="usuarioId">
          </p-dropdown>
            <ng-container
              *ngIf="form.get('usuarioId')?.invalid && form.get('usuarioId')?.touched">
              <app-form-group-error-message [control]="form.get('usuarioId')"></app-form-group-error-message>
            </ng-container>
          </div>
        </div>
        <ng-template pTemplate="footer">
          <div class="field col-12">
            <div class="flex justify-content-end">
              <button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right"
                  tooltipPosition="top"></button>
            </div>
          </div>
        </ng-template>
      </p-dialog>
    </form>
  </section>
  `
})
export class TramitesPendienteAsignacionComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  //Formulario
  formTitle = '';
  displayModal = false;
  form !: FormGroup;
  usuariosValidos: IGetUsuariosValidos[] = [];

  constructor(private _tr: TramRegistroService, private _fb: FormBuilder, private _t: TranslateService,
    private _ms: MessageService, private _lps: LoadingPanelService, private _tas: TramActividadService
  ) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.getActividadesPendienteAsignacion();
    this.translate().then(() => this.configTable());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      tipoDeTramite: this._t.get('common.tipoDeTramite'),
      actividad: this._t.get('common.actividad'),
      orden: this._t.get('common.orden'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      asignarUsuario: this._t.get('common.asignarUsuario'),
      porFavorCompleteTodosLosCamposRequeridos: this._t.get('msg.porFavorCompleteTodosLosCamposRequeridos'),
      usuarioAsignadoExitosamente: this._t.get('msg.usuarioAsignadoExitosamente'),
      exito: this._t.get('common.exito'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
    }));
  }

  configTable() {
    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'tipoTramite',
          header: this.trans.tipoDeTramite,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'actividad',
          header: this.trans.actividad,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          header: this.trans.orden,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'modal',
          header: '',
          label: this.trans.asignarUsuario,
          icon: 'pi pi-user-plus',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '15rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetActividadesPendienteAsignacion) => this.openAsignarModal(data),
        }
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;
  }

  getActividadesPendienteAsignacion() {
    this._tr.getActividadesPendienteAsignacion().subscribe({
      next: (data: IGetActividadesPendienteAsignacion[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  //#region Formulario
    configureForm() {
      this.form = this._fb.group({
        usuarioId: [null, [Validators.required]],
        actividadId: [null, [Validators.required]]
      });
    }
  
    openAsignarModal(data: IGetActividadesPendienteAsignacion) {
      this.resetForm();
      this.displayModal = true;
      this.getUsuariosValidosParaActividad(data.actividadId);
    }
  
    getUsuariosValidosParaActividad(actividadId: number) {
      this._lps.show(true);
      this._tas.getUsuariosValidosParaActividad(actividadId).subscribe({
        next: (usuarios: IGetUsuariosValidos[]) => {
          this._lps.hide();
          this.usuariosValidos = usuarios;
          this.form.get('actividadId')?.setValue(actividadId);
        }
      });
    }
  
    resetForm() {
      this.form.reset();
      this.usuariosValidos = [];
    }
  
    onSubmitForm() {
      if (this.form.pristine) {
        this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
        return;
      }
  
      if (this.form.invalid) {
        Utils.markAllFormControlsAsTouched(this.form);
        this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
        return;
      }
  
      this.asignacionManualUsuario();
    }
  
    asignacionManualUsuario() {
      this._lps.show(true);
      this._tas.asignacionManualUsuario(this.form.get('actividadId')?.value, this.form.get('usuarioId')?.value).subscribe({
        next: (response: boolean) => {
          this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.usuarioAsignadoExitosamente });
          this._lps.hide();
          this.getActividadesPendienteAsignacion();
          this.displayModal = false;
        }
      });
    }
    //#endregion
}
